<div class="fle justify-center bg-[#fafafaff] h-screen border-r-2">
  <div
    *ngIf="showSidebarAndHeader"
    id="bdSidebar"
    class="w-full flex justify-center flex-col p-3 text-black offcanvas-md offcanvas-start"
    tabindex="-1"
    aria-labelledby="bdSidebarLabel"
  >
    <div
      class="mb-[35px] flex justify-center items-center relative top-[0px] h-[24px] md:w-full text-[24px] font-[700] capitalize py-4"
    >
      <h1 class="leading-[24px]">Easy power</h1>
    </div>
    <ul
      class="my-nav nav nav-pills flex justify-cente items-start mb-auto uppercase space-y-2 font-medium"
    >
      <li class="hover:cursor-pointer nav-item mb-3 w-full">
        <div
          data-bs-dismiss="bdSidebar"
          class="w-full nav-link text-black"
          aria-current="page"
          routerLink="/dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="assets/icons/dashboaard.png" alt="Dashboard" class="icon" />
          Dashboard
        </div>
      </li>
      <li class="hover:cursor-pointer w-full nav-item mb-3">
        <div
          data-bs-dismiss="bdSidebar"
          class="w-full nav-link text-black"
          aria-current="page"
          routerLink="/product"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="assets/icons/albums.png" alt="Analytics" class="icon" />
          Products
        </div>
      </li>
      <li class="hover:cursor-pointer w-full nav-item mb-3">
        <div
          data-bs-dismiss="bdSidebar"
          class="w-full nav-link text-black"
          aria-current="page"
          routerLink="/categories"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="assets/icons/albums.png" alt="Analytics" class="icon" />
          Categories
        </div>
      </li>
      <li class="hover:cursor-pointer w-full nav-item mb-3">
        <div
          data-bs-dismiss="bdSidebar"
          class="w-full nav-link text-black"
          aria-current="page"
          routerLink="/order-list"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img
            src="assets/icons/document-text.png"
            alt="Order lists"
            class="icon text-wrap-nowrap"
          />
          Order list
        </div>
      </li>
      <li class="hover:cursor-pointer w-full nav-item mb-3">
        <div
          data-bs-dismiss="bdSidebar"
          class="w-full nav-link text-black uppercase"
          aria-current="page"
          routerLink="/services"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="assets/icons/Vector%20(1).png" alt="Service" class="icon" />
          services
        </div>
      </li>
      <div
        class="flex justify-content-between items-center text-[20px] font-[700] w-full mb-3"
      >
        <h1 class="leading-[23.7px]">Others</h1>
        <img src="assets/icons/chevron_down.png" />
      </div>
      <li class="hover:cursor-pointer w-full nav-item mb-3">
        <div
          data-bs-dismiss="bdSidebar"
          class="w-full nav-link text-black uppercase"
          aria-current="page"
          routerLink="/installment"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img
            src="assets/icons/dashboaard.png"
            alt="installment"
            class="icon"
          />
          Installment
        </div>
      </li>
      <li class="hover:cursor-pointer w-full nav-item mb-3">
        <div
          data-bs-dismiss="bdSidebar"
          class="w-full nav-link text-black uppercase"
          aria-current="page"
          routerLink="/promo-code"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img
            src="assets/icons/dashboaard.png"
            alt="installment"
            class="icon"
          />
          Promo Code
        </div>
      </li>
      <li class="hover:cursor-pointer w-full nav-item mb-3">
        <div
          data-bs-dismiss="bdSidebar"
          class="w-full nav-link text-black uppercase"
          aria-current="page"
          routerLink="/user-mgt"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img
            src="assets/icons/dashboaard.png"
            alt="installment"
            class="icon"
          />
          User Management
        </div>
      </li>
    </ul>
  </div>
  <!-- showSidebarAndHeader -->
  <div class="w-full bg-white">
    <div *ngIf="showHeader" class="p-2 block lg:hidden text-[#111]">
      <div
        *ngIf="showSidebarAndHeader"
        class="p-2 md:hidden flex gap-2 text-black w-full"
      >
        <a class="text-white" (click)="toggleSidebar()">
          <img src="../../../../assets/add.svg" alt="" />
        </a>
        <img
          src="../../../../assets/youngster/icons/logo1.png"
          class="ms-3"
          width="50"
          height="25"
        />
      </div>
    </div>

    <!-- <div class="flex flex-col w-full h-screen">
      <div *ngIf="showHeader" class="w-full">
        <app-header class="top-0"></app-header>
      </div>
      <div class="w-full hide-scrollbar">
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    </div> -->
  </div>
</div>
